export default __webpack_public_path__ + "6ef148026291e0e2ecca38ea0b7ec18c.png";